module.exports = __webpack_public_path__ + "static/media/exportIcon.50a82525.svg";